/** Links of link-preview content (or its card), shared by the frame and its card preview. */
import { safeWebUrl } from "@/lib/safe-web-url";

export interface PreviewLink {
  url: string;
  siteName?: string;
  title?: string;
  description?: string;
}

const MAX_LINKS = 10;

export function domainFromUrl(url: string): string {
  try {
    return new URL(url).hostname.replace("www.", "");
  } catch {
    return url;
  }
}

function toPreviewLink(raw: unknown): PreviewLink | null {
  if (typeof raw !== "object" || raw === null) return null;
  const row = raw as Record<string, unknown>;
  if (typeof row.url !== "string" || !safeWebUrl(row.url)) return null;
  return {
    url: row.url,
    siteName: typeof row.siteName === "string" ? row.siteName : undefined,
    title: typeof row.title === "string" ? row.title : undefined,
    description:
      typeof row.description === "string" ? row.description : undefined,
  };
}

/** `content.links`, or the legacy single link at the top level. */
export function linksFrom(content: Record<string, unknown>): PreviewLink[] {
  const raw = content.links;
  if (Array.isArray(raw)) {
    return raw
      .map(toPreviewLink)
      .filter((link): link is PreviewLink => link !== null)
      .slice(0, MAX_LINKS);
  }
  const legacy = toPreviewLink({
    url: content.url,
    siteName: content.siteName,
    title: content.title,
    description: content.description,
  });
  return legacy ? [legacy] : [];
}
